<template>
    <div class="bg-[#F0F0F0]  bottom-0 w-full shadow-lg z-50">
        <p class="text-sm py-2 px-4 lg:px-10">Copyright © 2025 by Pusat Data & Informasi SDA, Dinas SDA Prov. DKI Jakarta</p>
    </div>
</template>